import React from 'react';
import classes from './TenantInactiveError.module.scss';

export const TenantInactiveError: React.FC = () => (
  <p className={classes.container}>The tenant is not active.</p>
);
